module.exports = __webpack_public_path__ + "img/meauicon1.aa979b67.svg";